import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;

function AdminSetBatchDates() {
  const { batchId } = useParams();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [batchName, setBatchName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadBatch();
  }, [batchId]);

  const loadBatch = async () => {
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      const res = await axios.get(`${apiUrl}/api/admin/batches/${batchId}`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      setBatchName(res.data.batchname);
    } catch (err) {
      setError('Error loading batch');
    }
  };

  const submitDates = async () => {
    if (!startDate || !endDate) {
      setError('Both dates required');
      return;
    }
    if (new Date(startDate) >= new Date(endDate)) {
      setError('Start date must be before end date');
      return;
    }
    setLoading(true);
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      const res = await axios.put(`${apiUrl}/api/admin/batches/${batchId}/set-dates`, { start_date: startDate, end_date: endDate }, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (res.data.success) {
        setSuccess('Dates set successfully');
        setTimeout(() => navigate('/admin-view-batches'), 1500);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error setting dates');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li><Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">Home</Link></li>
                <li><span className="text-gray-500 fw-normal d-flex"><i className="ph ph-caret-right" /></span></li>
                <li><span className="text-main-600 fw-normal text-15">Set Batch Dates - {batchName}</span></li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-24">
              <h4 className="mb-16">Set Batch Dates for {batchName}</h4>
              {error && <div className="alert alert-danger mb-16">{error}</div>}
              {success && <div className="alert alert-success mb-16">{success}</div>}
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Start Date</label>
                  <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">End Date</label>
                  <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>
              </div>
              <button className="btn btn-primary mt-3" onClick={submitDates} disabled={loading}>
                {loading ? 'Saving...' : 'Set Dates'}
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default AdminSetBatchDates;